module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Dashboard\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-full grid-pad"
  }, [_c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "uix-list"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Wiadomości")])]), _vm._v(" "), _vm._l((_vm.newslettersMenu), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: item.route
          })
        }
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "uix-list"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Grupy i adresy e-mail")])]), _vm._v(" "), _vm._l((_vm.emailsMenu), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: item.route
          })
        }
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "uix-list"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Administracja")])]), _vm._v(" "), _vm._l((_vm.adminMenu), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: item.route
          })
        }
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4541d708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Dashboard.vue
// module id = 251
// module chunks = 0